export const EsignaturesMergeFieldStatusEnum = {
    Unknown: 0,
    Any: 1,
    Active: 2,
    Inactive: 3
};
